export const CREDIT_HELP_PATH = "credit-help";

export const PC_SITE_CONFIGURATION = {
	[CREDIT_HELP_PATH]: {
		showFeaturedCompany: true,
		preventRenderingCompanyListHeader: true,
	},
};
